export default {
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: '300px',
    gap: '10px',
  },
};
